import './Review.scss';
import Component from './Review.js';
export default Component;
